import React from 'react';

const NotFound = (props) => {

  return (
    <>
      <div className="marquet--404">
        <img src="https://irp.cdn-website.com/md/dmtmpl/f318b25a-4c62-44bb-a3dd-007c7573664e/dms3rep/multi/404_test.svg" />
      </div>
    </>
  )
}
export default NotFound;